var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f-popover',_vm._b({ref:"popover",staticClass:"ftooltip",attrs:{"attach-to":_vm.attach}},'f-popover',{ ..._vm.$attrs, ..._vm.$props, ..._vm.dProps },false),[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }